import { render } from "./NextDD.vue?vue&type=template&id=d979c9c4"
import script from "./NextDD.vue?vue&type=script&lang=js"
export * from "./NextDD.vue?vue&type=script&lang=js"

import "./NextDD.vue?vue&type=style&index=0&id=d979c9c4&lang=css"

import exportComponent from "/usr/src/app/vue-goparity/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__